import axios from "axios";
import { API } from "./api";

const ptoken = (token) => ({ headers: { "X-Project-Token": token } });

export const createProject = () => axios.post(`${API}/projects`).then((r) => r.data);

export const patchProject = (id, token, body) =>
  axios.put(`${API}/projects/${id}`, body, ptoken(token)).then((r) => r.data);

export const markProjectSaved = (id, token) =>
  axios.post(`${API}/projects/${id}/save`, {}, ptoken(token)).then((r) => r.data);

export const fetchProject = (id, token) =>
  axios.get(`${API}/projects/${id}?token=${encodeURIComponent(token)}`).then((r) => r.data);

export const fetchProjectByCode = (code, token) =>
  axios
    .get(`${API}/projects/by-code/${encodeURIComponent(code)}?token=${encodeURIComponent(token)}`)
    .then((r) => r.data);

export const projectHeartbeat = (id, token, snapshot) =>
  axios.post(`${API}/projects/${id}/heartbeat`, { snapshot }, ptoken(token)).then((r) => r.data);

export const projectMessages = (id, token) =>
  axios.get(`${API}/projects/${id}/messages?token=${encodeURIComponent(token)}`).then((r) => r.data);

export const sendProjectMessage = (id, token, text) =>
  axios.post(`${API}/projects/${id}/messages`, { text }, ptoken(token)).then((r) => r.data);

export const setProjectContact = (id, token, body) =>
  axios.post(`${API}/projects/${id}/contact`, body, ptoken(token)).then((r) => r.data);

const auth = (token) => ({ headers: { "X-Admin-Token": token } });

export const adminLive = (token) => axios.get(`${API}/admin/live`, auth(token)).then((r) => r.data);
export const adminProjects = (token) =>
  axios.get(`${API}/admin/projects`, auth(token)).then((r) => r.data);
export const adminProject = (token, id) =>
  axios.get(`${API}/admin/projects/${id}`, auth(token)).then((r) => r.data);
export const adminReply = (token, id, text) =>
  axios.post(`${API}/admin/projects/${id}/messages`, { text }, auth(token)).then((r) => r.data);
export const adminChats = (token) =>
  axios.get(`${API}/admin/chats`, auth(token)).then((r) => r.data);
export const adminGetPresence = (token) =>
  axios.get(`${API}/admin/presence`, auth(token)).then((r) => r.data);
export const adminSetPresence = (token, online) =>
  axios.put(`${API}/admin/presence`, { online }, auth(token)).then((r) => r.data);

export const adminDeleteProject = (token, id) =>
  axios.delete(`${API}/admin/projects/${id}`, auth(token)).then((r) => r.data);
export const adminDeleteProjects = (token, ids) =>
  axios.post(`${API}/admin/projects/delete`, { ids }, auth(token)).then((r) => r.data);
export const adminGetCleanup = (token) =>
  axios.get(`${API}/admin/cleanup`, auth(token)).then((r) => r.data);
export const adminSetCleanup = (token, days) =>
  axios.put(`${API}/admin/cleanup`, { days }, auth(token)).then((r) => r.data);
export const adminStats = (token) =>
  axios.get(`${API}/admin/stats`, auth(token)).then((r) => r.data);
export const adminGetNotifications = (token) =>
  axios.get(`${API}/admin/notifications`, auth(token)).then((r) => r.data);
export const adminSetNotifications = (token, body) =>
  axios.put(`${API}/admin/notifications`, body, auth(token)).then((r) => r.data);
export const adminTestNotification = (token) =>
  axios.post(`${API}/admin/notifications/test`, {}, auth(token)).then((r) => r.data);

const saveBlob = (res, fallback) => {
  const cd = res.headers["content-disposition"] || "";
  const match = cd.match(/filename="?([^";]+)"?/);
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = match ? match[1] : fallback;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};

const download = (token, path, fallback, body) =>
  axios({
    url: `${API}${path}`,
    method: body ? "post" : "get",
    data: body,
    responseType: "blob",
    headers: { "X-Admin-Token": token },
  }).then((res) => saveBlob(res, fallback));

export const downloadListino = (token, format) =>
  download(token, `/admin/export/listino?format=${format}`, `listino.${format}`);
export const downloadTemplate = (token) =>
  download(token, "/admin/export/listino-template", "modello-listino.xlsx");
export const downloadProjectFile = (token, id, format) =>
  download(token, `/admin/export/project/${id}?format=${format}`, `progetto.${format}`);
export const downloadOrderFile = (token, id) =>
  download(token, `/admin/export/order/${id}`, "ordine.xlsx");
export const downloadProjectsList = (token, filters) =>
  download(token, "/admin/export/projects", "progetti.xlsx", filters || {});

export const importPreview = (token, file) => {
  const form = new FormData();
  form.append("file", file);
  return axios
    .post(`${API}/admin/import/listino/preview`, form, {
      headers: { "X-Admin-Token": token },
    })
    .then((r) => r.data);
};
export const importConfirm = (token, stagingId) =>
  axios
    .post(`${API}/admin/import/listino/confirm`, { staging_id: stagingId }, auth(token))
    .then((r) => r.data);
export const importHistory = (token) =>
  axios.get(`${API}/admin/import/history`, auth(token)).then((r) => r.data);
export const importRestore = (token, backupId) =>
  axios.post(`${API}/admin/import/restore/${backupId}`, {}, auth(token)).then((r) => r.data);
export const confirmProjectOrder = (token, id) =>
  axios.post(`${API}/admin/projects/${id}/confirm`, {}, auth(token)).then((r) => r.data);
